class CardProductAddon extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.optionsWrapper = this.querySelector("[data-options]");
    this.form = this.querySelector("form");
    this.submitButton = this.querySelector('[name="add"]');
    this.price = this.querySelector("[data-product-price]");
    this.currentProduct = JSON.parse(
      this.querySelector("[data-product-json]").textContent
    );
    if (this.querySelector("[data-associated-products]")) {
      this.products = JSON.parse(
        this.querySelector("[data-associated-products]").textContent
      );
      this.currentProduct = this.products[0];
    }
    this.currentVariant = null;
    const formattedPricesEl = this.querySelector("[data-formatted-prices]");
    this.formattedPrices = formattedPricesEl
      ? JSON.parse(formattedPricesEl.textContent)
      : {};
    this.setHandlers();
  }

  setHandlers() {
    this.querySelector("[data-toggle-options]").addEventListener(
      "click",
      this.toggleOptions.bind(this)
    );
    this.querySelectorAll("[data-swatch]").forEach((swatch) => {
      swatch.addEventListener("click", this.onSwatchChange.bind(this));
    });
    this.querySelectorAll("input").forEach((input) => {
      input.addEventListener("change", this.onVariantChange.bind(this));
    });
  }

  onSwatchChange(e) {
    e.preventDefault();
    const swatch = e.target.closest("[data-swatch]") || e.target;
    if (swatch.classList.contains("is-active")) return;
    this.updateProduct(
      this.products.find(
        (product) => product.id === Number(swatch.dataset.productId)
      ),
      swatch.dataset.formattedPrice
    );
  }

  updateProduct(product, formattedPrice) {
    this.currentProduct = product;
    this.updateSwatches();
    this.updateImage();
    this.updateFormattedPrice(
      formattedPrice || this.getFormattedProductPrice(product)
    );
    this.updateURL();
    this.clearSelections();
    this.resetSubmitButton();
    this.updateAvailabilities();
  }

  updateSwatches() {
    this.querySelectorAll("[data-swatch]").forEach((swatch) => {
      swatch.classList.toggle(
        "is-active",
        this.currentProduct.id === Number(swatch.dataset.productId)
      );

      if (swatch.classList.contains("is-active")) {
        const valueDowncased = swatch.dataset.value.toLowerCase();
        const valueCapitalized = valueDowncased.replace(
          valueDowncased[0],
          valueDowncased[0].toUpperCase()
        );
        this.querySelector('input[name="Color"]').value = swatch.dataset.value;
        this.querySelector("[data-current-color]").textContent =
          valueCapitalized;
      }
    });
  }

  updateImage() {
    this.querySelector(
      "[data-product-image]"
    ).src = `${this.currentProduct.featured_image}&width=360`;
  }

  getFormattedProductPrice(product) {
    return this.formattedPrices?.[product.id]?.price;
  }

  getFormattedVariantPrice(product, variant) {
    return this.formattedPrices?.[product.id]?.variants?.[variant.id];
  }

  updateFormattedPrice(formattedPrice) {
    if (!formattedPrice || !this.price) return;
    this.price.classList.remove("visibility-hidden");
    this.price.textContent = formattedPrice;
  }

  updateURL() {
    this.querySelectorAll("[data-product-url]").forEach((url) =>
      url.setAttribute("href", `/products/${this.currentProduct.handle}`)
    );
  }

  clearSelections() {
    this.querySelectorAll('input[name="Size"]').forEach(
      (input) => (input.checked = false)
    );
    this.currentVariant = null;
    this.querySelector('[name="id"]').value = "";
  }

  resetSubmitButton() {
    this.submitButton.querySelector("span").textContent = this.products
      ? window.variantStrings.select_size
      : window.variantStrings.select_options;
    this.submitButton.classList.add("not-allowed");
    this.submitButton.classList.remove("loading");
    this.submitButton.classList.remove("unavailable");
  }

  onVariantChange() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    const options = fieldsets
      .sort((a, b) => {
        const positionA = Number(a.getAttribute("data-option-position"));
        const positionB = Number(b.getAttribute("data-option-position"));
        return positionA > positionB ? 1 : -1;
      })
      .map((fieldset) => {
        return Array.from(fieldset.querySelectorAll("input")).find(
          (radio) => radio.checked
        )?.value;
      });
    this.currentVariant = this.currentProduct.variants.find((variant) => {
      return !variant.options
        .map((option, index) => {
          return options[index] === option;
        })
        .includes(false);
    });

    this.toggleAddButton(true, "", false);

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.querySelector('[name="id"]').value = this.currentVariant.id;
      this.updateFormattedPrice(
        this.getFormattedVariantPrice(this.currentProduct, this.currentVariant)
      );
      this.toggleAddButton(
        !this.currentVariant.available,
        window.variantStrings.soldOut
      );
      this.submitButton.classList.remove("loading");
    }
  }

  setUnavailable() {
    this.submitButton.querySelector("span").textContent =
      window.variantStrings.unavailable;
    this.submitButton.classList.add("unavailable");
    this.submitButton.classList.remove("loading");
    this.price.classList.add("visibility-hidden");
  }

  toggleAddButton(disable = true, text) {
    this.submitButton.classList.remove("unavailable");
    this.submitButton.classList.add("loading");

    if (disable) {
      this.submitButton.setAttribute("disabled", "disabled");
      if (text) this.submitButton.querySelector("span").textContent = text;
    } else {
      this.submitButton.removeAttribute("disabled");
      this.submitButton.querySelector("span").textContent =
        window.variantStrings.addToCart;
    }

    this.submitButton.classList.remove("not-allowed");
  }

  updateAvailabilities() {
    if (!this.currentProduct) return;
    this.currentProduct.options.forEach((option, index) => {
      if (this.products && option === "Color") return;
      this.currentProduct.variants.forEach((variant) => {
        const input = this.querySelector(
          `[name="${option}"][value="${variant.options[index]}"]`
        );
        input?.classList.toggle("disabled", !variant.available);
      });
    });
  }

  toggleOptions(e) {
    if (!this.optionsWrapper) return this.form.submit();
    this.optionsWrapper.classList.remove("hidden");
    e.target.classList.add("hidden");
  }
}

customElements.define("card-product-addon", CardProductAddon);
